import { useEffect, useMemo, useState } from "react"
import { FieldType, FieldValue, FilterField, Filters, O } from "../../../../../features/ui"
import { DataType } from '../../../../../tables'
import { useAdministrationHooks } from "../../../hooks/administrationHooks"
import { usePaymentTypeLoaders } from "../../../loaders/paymentTypeLoaders"

type Props = {
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'paymentType'

export const PaymentTypeFilters = (props: Props) => {
    const { onSearchStart, onSearchDone } = props

    const [listLength, setListLength] = useState<number>(-1)
    const [searchText, setSearchText] = useState<string>()

    const { searchPaymentTypes } = useAdministrationHooks()

    const paymentTypeLoaders = usePaymentTypeLoaders()

    const paymentTypes = useMemo(() => paymentTypeLoaders().findAllPaymentTypes(true), [])

    useEffect(() => {
        if (paymentTypes.length !== listLength) {
            search(searchText)
        }
        setListLength(paymentTypes.length)
    }, [paymentTypes])

    const search = (searchTextParam?: string) => {
        onSearchStart()
        searchPaymentTypes(paymentTypes, searchTextParam).then(searchedList => {
            setTimeout(() => onSearchDone(searchedList as DataType[]), 100)
        })
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por nombre',
        icon: 'search',
        space: 6,
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}
